import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from '@config';
import { StateService, States } from '@state';
import { AuthService } from '@auth';
import { ThemeService } from '@themes';

@Component({
    selector: 'registration',
    templateUrl: './ext.login.registration.info.template.html',
    standalone: false
})
export class ExtLoginRegistrationInfoComponent {
    constructor(
        private router: Router,
        private config: Config,
        private stateService: StateService,
        private authService: AuthService,
        private themeService: ThemeService
    ) {
        if (!config.serverConfig.SIGNUP_EMAIL) {
            this.router.navigateByUrl('/Login');
        } else {
            this.showSignup = themeService.currentThemeConfig ? themeService.currentThemeConfig.showSignUp : false;
            this.subscriptions.push(this.themeService.data.subscribe((data: any) => {
                if (data) {
                    this.showSignup = data.showSignUp;
                }
            }));
            this.checkSignUp();
        }
    }

    private checkSignUp(){
        const signUpInfoJson = localStorage.getItem('signupData');
        if (signUpInfoJson) {
            try {
                const signUpInfo = JSON.parse(signUpInfoJson);
                if (signUpInfo.Email && signUpInfo.NewActivationKey && signUpInfo.TermsOfUse) {
                    this.router.navigateByUrl('/Registration');
                }
            } catch {
                // ignored
            }
        }
    }

    public register() {
        this.router.navigateByUrl('/Registration');
    }

    public login() {
        this.stateService.change(States.userMustRegister, false);
        this.router.navigateByUrl('/Login');
    }

    public logOut() {
        this.authService.disconnect({force: true});
    }

    private subscriptions = []

    public ngOnDestroy() {
        this.subscriptions.forEach((current) => {
            current.unsubscribe();
        })
    }

    public showSignup: boolean;
}